import { gameAction } from "_actions";
import { GameService } from "_services";
import React, { useEffect, useState } from "react";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import ScrollableListView from "../ScrollableListView";
import { Helmet } from "react-helmet";
import { useParams, useNavigate } from "react-router-dom";
import { ServiceURLs } from "_services";
import i18n from "i18n";
import { isBrowser, isMobile } from "react-device-detect";
import { detroidVirtualGames } from "BaseServiceURLs";
import { detroidGames } from "BaseServiceURLs";
import LoadingDots from "../../LoadingDots";
import { checkGameType } from "BaseServiceURLs";

import { gamesGameTypes } from "BaseServiceURLs";
import { tvBetGameTypes } from "BaseServiceURLs";
import { virtualGameTypes } from "BaseServiceURLs";
import { getReturnUrl } from "BaseServiceURLs";
import Emitter from "_actions/emitter";
import { Modal, Button } from "rsuite";
import { isGameLaunchAllowed } from "../gameLaunchAccess";

const Innova = (props) => {
  const { user, loggedIn, sports, games, UpdateGames, demo, gamesLoading } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [isDataError, setIsDataError] = useState(null);
  const [showLimitModal, setShowLimitModal] = useState(false);
  const navigate = useNavigate();

  function GetParams() {
    let params = useParams();
    return params;
  }
  let params = GetParams();

  // name_middleware sistemini destekleyen oyun bulma fonksiyonu
  const findGameData = (games, providerId, gameId) => {
    debugger;
    if (!games) return null;
    
    // Önce doğrudan key'i kontrol et
    if (games.hasOwnProperty(providerId+'_innova')) {
      return games[providerId+'_innova'].find((x) => x.id == gameId);
    }
    if (games.hasOwnProperty(providerId)) {
      return games[providerId].find((x) => x.id == gameId);
    }
    
    // Bulunamazsa, name_middleware formatındaki key'leri dene
    const commonMiddlewares = ['innova', 'matgame', 'blas975'];
    for (const middleware of commonMiddlewares) {
      const key = `${providerId}_${middleware}`;
      if (games.hasOwnProperty(key)) {
        return games[key].find((x) => x.id == gameId);
      }
    }
    
    return null;
  };

  //Emitter.emit("LIMIT_EXCEED", true);
  useEffect(() => {
    const handleLimitExceed = (data) => {
      setShowLimitModal(data);
    };

    Emitter.on("LIMIT_EXCEED", handleLimitExceed);

    return () => {
      Emitter.off("LIMIT_EXCEED", handleLimitExceed);
    };
  }, []);



  const tryLaunchGame = () => {
    if (
      !loading &&
      params &&
      params.ProviderId &&
      params.GameId &&
      props.games
    ) {
      const _data = findGameData(props.games, params.ProviderId, params.GameId);

      if (_data) {
        if (!isGameLaunchAllowed(_data, params.ProviderId, 'innova', props.permissions, loggedIn)) {
          navigate("/");
          return;
        }
        if (!demo) {
          getGameDetail(_data.id, _data);
        } else {
          getGameDemoDetail(_data.id, _data);
        }
      } else if (!gamesLoading) {
       }
    }
  };

  useEffect(() => {
    tryLaunchGame();
  }, []);

  useEffect(() => {
    tryLaunchGame();
  }, [games, gamesLoading]);

  let startget = false;

  const getGameDetail = (id_game, gdata) => {
    if (!startget) {
      startget = true;
      setLoading(true);

      debugger;

      const _type = checkGameType(gdata);
      const returnUrl = getReturnUrl(_type, gdata);
      debugger;
      GameService.GET_INNOVA_SLOT_GAME(
        id_game, props.currentLang, demo, _type, returnUrl
      )
        .then((res) => {

          debugger;
          //alert(JSON.stringify(res));

          /*
          
           setLoading(false);
              debugger;
              alert(JSON.stringify(res));
              setData(res.url);
              //  openInNewTab(res.url);
              startget = false;
          */
          const gameUrl = res.dynamicValue.gameUrl;
          setData(gameUrl);

          setLoading(false);
          startget = false;


        })
        .catch((err) => {
          debugger;
          //  alert('Error 1 : ' + err);
          setLoading(false);
          setIsDataError(true);

        });
    }
  };

  const getGameDemoDetail = (id_game, data) => {
    if (!startget) {
      startget = true;
      setLoading(true);
      GameService.GET_DETROIT_SLOT_GAME(id_game, props.currentLang)
        .then((res) => {
          setLoading(false);
          debugger;
          setData(res.url);
          // openInNewTab(res.url);
        })
        .catch((err) => {
          debugger;

          setLoading(false);
        });
    }
  };
  /*
  const adjustHeight = () => {
    const windowHeight = window.innerHeight;
     try {
      document.querySelector(".gameiframe").style.height = `${windowHeight}px`;
    } catch (error) {
      
    }
  };

  useEffect(() => {
    window.addEventListener("DOMContentLoaded", adjustHeight);
    window.addEventListener("resize", adjustHeight);
  }, []);
*/

  function openInNewTab(url) {
    var newWindow = window.open(url);
    newWindow.focus();
  }

  return (
    <Translation>
      {(t) => (
        <>
          <Helmet>
            <title>{t("TITLE_CASINO")}</title>

          </Helmet>
          <div className="fixed inset-0 w-full h-screen flex justify-center items-center z-[99999] bg-black">
            {isDataError ? (<div className="text-white text-2xl font-bold">Error loading game
              <br />
              <button className="bg-blue-500 text-white px-4 py-2 rounded-md" onClick={() => {
                window.location.reload();
              }}>Reload</button>
            </div>) : <LoadingDots />}
          </div>
          {data && <iframe style={{ width: "100%", height: "100dvh", position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: '99999' }} src={data} allowfullscreen></iframe>}

          <Modal
            open={showLimitModal}
            onClose={() => setShowLimitModal(false)}
            size="sm"
            backdrop={true}
            className="custom-modal-limit"
            style={{ zIndex: '99999', backgroundColor: '#1c1c1cbf' }}

          >
            <Modal.Header>
              <Modal.Title className="text-warning">
              {showLimitModal&& showLimitModal.limit > 0 ? t("LIMIT_EXCEED_MESSAGE", { limit: showLimitModal.limit + " " + props.user.Currency }) : t("LIMIT_EXCEED_MESSAGE_NO_LIMIT")}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body >
              <p className="text-white text-base">
                {t("LIMIT_EXCEED_MESSAGE")}
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button
                onClick={() => setShowLimitModal(false)}
                appearance="primary"
                className="btn btn-primary"
              >
                {t("BUTTON_OK")}
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </Translation>
  );
};
// height: "calc(100vh - 72px)",
const mapStateToProps = (state, props) => {
  const { authentication, game } = state;
  const { user, loggedIn, currentLang, permissions } = authentication;
  const { sports, games, loading } = game;
  return {
    user,
    loggedIn,
    sports,
    games,
    currentLang,
    permissions,
    gamesLoading: loading,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateGames: (data) => dispatch(gameAction.UpdateGamesData(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Innova);
